import React from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import FeedbackService from "../../services/FeedbackService";

export default function NewFeedbackModal({
  isModalOpen,
  setModalOpen,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log(data);

    const response = await FeedbackService.createFeedback(data);

    if (response) {
      toast.success("Feedback criado com sucesso!", {
        // position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      // console.log(error)
      toast.error("Ops! Algo deu errado", {
        // position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit px-6 py-8 relative transform rounded-lg bg-white text-left shadow-xl transition-all">
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col text-left gap-4">
                <div className="text-white text-xl font-bold font-['Work Sans'] bg-gray-800 rounded-full px-4">
                  Criar novo Feedback
                </div>
              </div>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm">

                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Descrição do Feedback / Bug / Sugestão:
                      </label>
                      <textarea
                        {...register("description", {
                          required: true,
                        })}
                        className={`
                              w-full h-[100px] p-4 bg-white rounded-lg justify-start items-center inline-flex resize-none 
                              text-neutral-600 text-sm font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              ${
                                errors?.description?.type ===
                                "required"
                                  ? "border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                          `}
                        placeholder={"Observação do Antedimento"}
                      ></textarea>
                      {errors?.description?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                    <button
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
